import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { getWebsiteBrandingFromSettings } from "../../utility/websiteBranding";
import { buildRoundedFaviconHref } from "../../utility/roundedFavicon";

function upsertLink(rel, href) {
  if (!href) return;
  let link = document.querySelector(`link[rel="${rel}"]`);
  if (!link) {
    link = document.createElement("link");
    link.rel = rel;
    document.head.appendChild(link);
  }
  link.href = href;
}

export default function WebsiteDocumentHead() {
  const siteData = useSelector((state) => state.settingsData);
  const settings = siteData?.settingData || {};
  const branding = useMemo(
    () => getWebsiteBrandingFromSettings(settings),
    [settings]
  );

  useEffect(() => {
    let cancelled = false;
    document.title = branding.siteName;

    (async () => {
      const href = await buildRoundedFaviconHref(branding.faviconUrl);
      if (cancelled || !href) return;
      upsertLink("icon", href);
      upsertLink("shortcut icon", href);
    })();

    return () => {
      cancelled = true;
    };
  }, [branding.siteName, branding.faviconUrl]);

  return null;
}
